import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9db3e75c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "ABOUT", -1))
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "copyright" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nbc-logo" }, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", {
      class: "description",
      innerHTML: _ctx.description
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_ctx.year === 2023)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "State Key Laboratory of NBC Protection for Civilian Copyright © 2023"))
        : (_openBlock(), _createElementBlock("span", _hoisted_7, "State Key Laboratory of NBC Protection for Civilian Copyright © 2023-" + _toDisplayString(_ctx.year), 1))
    ])
  ]))
}